import { Injectable } from '@angular/core';
import { GenericRepository } from './generic.repository';

export class EmployeeItem {
  full_name?: string;
  firstname?: string;
  id?: number;
  is_owner?: false;
  lastname?: string;
  phone?: string;
  roles?: string[];
  terminalcode?: string;
  userid?: string;
  lastActivity?: Date;
  permissions?: string[];
}

const TABLE_KEY = '__employees';
@Injectable({ providedIn: 'root' })
export class EmployeeRepository {
  private _cache: EmployeeItem[] = [];
  private _cacheDict: { [id: string]: EmployeeItem } = {};

  constructor(private _repository: GenericRepository) {}

  getEmployeeName(id: string) {
    if (this._cacheDict && this._cacheDict[id]) {
      return this._cacheDict[id].full_name;
    }

    return null;
  }

  getEmployeesMap(): Promise<Map<string, EmployeeItem>> {
    return this._repository
      .getItems(TABLE_KEY)
      .then(
        (employees: EmployeeItem[]) =>
          new Map(employees.map((employee) => [employee.userid, employee]))
      );
  }

  async getEmployees(): Promise<EmployeeItem[]> {
    if (this._cache && this._cache.length) {
      return this._cache;
    }

    const res = await this._repository.getItems<EmployeeItem>(TABLE_KEY);
    this._saveCache(res);
    return res;
  }

  getEmployee(employeeId: string): Promise<EmployeeItem> {
    return this.getEmployees().then((employees: EmployeeItem[]) =>
      employees.find((employee) => employee.userid == employeeId)
    );
  }

  loadEmployees(employees: EmployeeItem[]): Promise<void> {
    this._saveCache(employees);
    return this._repository.getItems(TABLE_KEY).then((res: EmployeeItem[]) => {
      employees.forEach((employee) => {
        const storedEmployee = res.find((e) => e.userid == employee.userid);
        if (storedEmployee != null) {
          employee.lastActivity = storedEmployee.lastActivity;
        }
      });

      return this._repository.loadItems(TABLE_KEY, employees);
    });

    // return this._repository.loadItems(TABLE_KEY, employees);
  }

  async saveEmployee(employee: EmployeeItem): Promise<void> {
    await this._repository.updateItem(TABLE_KEY, employee, 'userid');
    const res = await this._repository.getItems<EmployeeItem>(TABLE_KEY);
    this._saveCache(res);
  }

  clearStorage() {
    this._saveCache([]);
    return this._repository.deleteTable(TABLE_KEY);
  }

  private _saveCache(employees: EmployeeItem[]) {
    const _employees = employees.map((e) => {
      if (e.firstname) {
        e.full_name = e.firstname;
      }
      if (e.lastname) {
        e.full_name += ` ${e.lastname}`;
      }
      
      return e;
    });

    this._cache = _employees;
    this._cacheDict = _employees.reduce(
      (prev: { [key: string]: EmployeeItem }, current) => {
        prev[current.userid] = current;
        return prev;
      },
      {}
    );
  }
}
